import { ToastrService } from 'ngx-toastr';

import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';

import { Validators } from '@bp/shared/features/validation';
import { takeUntilDestroyed } from '@bp/shared/models/common';
import { FormMetadataEntityBaseComponent } from '@bp/shared/components/metadata';
import { DTO } from '@bp/shared/models/metadata';
import { FORM_FIELD_DEFAULT_OPTIONS, IFormFieldDefaultOptions } from '@bp/shared/components/core';

import { CreateAccountApiRequest } from '@bp/admins-shared/domains/identity';

@Component({
	selector: 'bp-create-account-form',
	templateUrl: './create-account-form.component.html',
	styleUrls: [ './create-account-form.component.scss' ],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [
		{
			provide: FORM_FIELD_DEFAULT_OPTIONS,
			useValue: <IFormFieldDefaultOptions>{
				appearance: 'round',
				compact: true,
			},
		},
	 ],
})
export class CreateAccountFormComponent extends FormMetadataEntityBaseComponent<CreateAccountApiRequest> {

	@Input() email?: string;

	@Output() readonly login = new EventEmitter();

	override metadata = CreateAccountApiRequest.getClassMetadata();

	override onSubmitShowInvalidInputsToast = false;

	controlsScheme = [
		this.metadata.properties.firstName,
		this.metadata.properties.lastName,
	];

	constructor(
		fb: UntypedFormBuilder,
		cdr: ChangeDetectorRef,
		toaster: ToastrService,
	) {
		super(fb, cdr, toaster);

	   this._setupForm({
			firstName: null,
			lastName: null,
			password: [
				Validators.required,
				Validators.password(),
			],
			confirmPassword: [
				Validators.required,
				Validators.password(),
				Validators.confirmPassword(),
			],
		});

		this._onPasswordChangeRevalidateConfirmPassword();
	}

	override factory = (dto?: DTO<CreateAccountApiRequest>): CreateAccountApiRequest => new CreateAccountApiRequest(dto);

	private _onPasswordChangeRevalidateConfirmPassword(): void {
		this.controls!.password!.valueChanges
			.pipe(takeUntilDestroyed(this))
			.subscribe(() => void this.controls!.confirmPassword!.updateValueAndValidity());
	}
}
